import { defineMessages } from 'utils/intl';

export default defineMessages({
  title: 'Pytania i odpowiedzi',
  description:
    'Znajdziesz tu odpowiedzi na najczęściej zadawane pytania. Jeśli potrzebujesz dodatkowej pomocy, wyślij nam wiadomość poprzez {link}',
  link: 'formularz kontaktowy',
  formHeader: 'Nie znalazłeś odpowiedzi?',
  formDescription: 'Napisz do nas, pomożemy',
});
